/** @jsx jsx */
import React, { useEffect, useState } from "react";

import useAPI from "../../helperHooks/useAPI";

import moment from "moment";

import {
  DocumentsListContents as CONSTANTS,
  DocumentHeader
} from "./DocumentsConstants";

import {
  TABLE_ROW_CLASS_NAME,
  DATE_FORMAT,
  LIST_FETCH_SIZE,
  SORT_ORDER,
  TABLE_TOTAL_COUNT
} from "../../Constants";

import { DocumentsService } from "../../services/documentsRepositoryService/index";

import { jsx } from "@emotion/core";

import { documentsStyles, tableScroll } from "./DocumentsStyles";

import { Typography, Table, Button, Icon, Pagination, Card } from "antd";
import {
  DocumentsListType,
  DocumentRepositoryDetails
} from "../../services/documentsRepositoryService/DocumentsRepositoryService.type";
import useDocumentDownload from "../../helperHooks/useDocumentDownload";
import { ColumnProps } from "antd/lib/table";

const { Text } = Typography;

const Documents: React.FC = () => {
  const { callAPI: getDocumentsList, ...DocumentsListData } = useAPI(
    DocumentsService.getDocumentsList
  );

  const { loading, response } = DocumentsListData;

  const { download } = useDocumentDownload();
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(SORT_ORDER.Descend);

  const documentListTableData: DocumentsListType["documentsDataList"] =
    (response &&
      response.documentsDataList.map(item => {
        return {
          ...item,
          updatedOn: moment(item.updatedOn).format(DATE_FORMAT),
          docType:
            item.docType === "POI"
              ? CONSTANTS.DocumentType.POI
              : item.docType === "POA"
              ? CONSTANTS.DocumentType.POA
              : item.docType === "POB"
              ? CONSTANTS.DocumentType.POB
              : item.docType
        };
      })) ||
    [];

  useEffect(() => {
    getDocumentsList({
      paginate: true,
      page_size: LIST_FETCH_SIZE,
      page,
      sortBy: sort === SORT_ORDER.Ascend ? "updated_on" : "-updated_on"
    });
  }, [getDocumentsList, page, sort]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleSortChange = (order: string) => {
    setSort(order as SORT_ORDER);
  };

  const columns: Array<ColumnProps<DocumentRepositoryDetails>> = [
    {
      title: CONSTANTS.labels.docType,
      dataIndex: "docType",
      key: "docType",
      width: 150,
      ellipsis: true
    },
    {
      title: CONSTANTS.labels.subDocType,
      dataIndex: "subDocType",
      key: "subDocType",
      width: 150,
      ellipsis: true
    },
    {
      title: CONSTANTS.labels.uploadedBy,
      dataIndex: "uploadedBy",
      key: "uploadedBy",
      width: 150,
      ellipsis: true
    },
    {
      title: CONSTANTS.labels.updatedOn,
      dataIndex: "updatedOn",
      key: "updatedOn",
      sorter: true,
      width: 150,
      ellipsis: true
    },
    {
      title: CONSTANTS.labels.documentURL,
      dataIndex: "s3Key",
      key: "s3Key",
      width: 100,
      ellipsis: true,
      render: (documentUrl: string) => {
        return (
          documentUrl && (
            <Button
              type="link"
              onClick={() => {
                download(documentUrl);
              }}
              className="p-0"
            >
              <Icon type="download" />
            </Button>
          )
        );
      }
    }
  ];

  return (
    <div css={documentsStyles} className="p-3">
      <Text className="document-header">{DocumentHeader}</Text>
      <Card className="mt-3">
        <Table
          rowKey="s3Key"
          dataSource={documentListTableData}
          columns={columns}
          rowClassName={TABLE_ROW_CLASS_NAME}
          pagination={false}
          loading={loading}
          scroll={tableScroll}
          onChange={(_, __, sorter) => handleSortChange(sorter.order)}
        />
        <Pagination
          hideOnSinglePage
          showQuickJumper
          showTotal={TABLE_TOTAL_COUNT}
          current={page}
          defaultPageSize={LIST_FETCH_SIZE}
          total={response?.count}
          onChange={handlePageChange}
        />
      </Card>
    </div>
  );
};

export default Documents;
